import React, { useState, useRef, ChangeEventHandler } from 'react';
import {
	FileUploadContainer,
	FormField,
	DragDropText,
	UploadFileBtn
} from './ImageUpload.styles';
import * as Helpers from '../../helpers/helpers';
import { UploadedImages } from '../UploadedImages/UploadedImages';

interface ImageUplaodProps {
	label: string;
	otherProps: any;
}

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 50000000;

export const ImageUplaod: React.FC<ImageUplaodProps> = ({
	label,
	otherProps
}) => {
	const fileInputField = useRef<HTMLInputElement>(null);
	const [images, setImages] = useState<any>([]);
	const [files, setFiles] = useState<any>({});

	const handleUploadBtnClick = () => {
		if (fileInputField.current !== null) {
			fileInputField.current.click();
		}
		setFiles({});
	};

	const addNewFiles = (newFiles: any) => {
		for (let file of newFiles) {
			if (file.size <= DEFAULT_MAX_FILE_SIZE_IN_BYTES) {
				if (!otherProps.multiple) {
					return { file };
				}
				files[file.name] = file;
			}
		}
		return { ...files };
	};

	const handleImageUpload = React.useCallback<
		ChangeEventHandler<HTMLInputElement>
	>(
		(event) => {
			// `event.target.files` is of type `FileList`,
			// we convert it to Array for easier manipulation.
			const fileList = event.target.files;
			const fileArray = fileList ? Array.from(fileList) : [];

			// Uploaded images are read and the app state is updated.
			const fileToImagePromises = fileArray.map(Helpers.fileToImageURL);

			Promise.all(fileToImagePromises).then(setImages);
		},
		[setImages]
	);

	const clean = React.useCallback(() => {
		setImages([]);
		setFiles({});
		images.forEach((image: any) => {
			URL.revokeObjectURL(image.src);
		});
	}, [images]);

	const generatePdfFromImages = React.useCallback(() => {
		console.log(images);
		Helpers.generatePdfFromImages(images);
		clean();
	}, [images, clean]);

	const handleNewFileUpload = (e: any) => {
		const { files: newFiles } = e.target;
		setFiles({});
		if (newFiles.length) {
			let updatedFiles = addNewFiles(newFiles);
			setFiles(updatedFiles);
			handleImageUpload(e);
		}
	};

	const removeFile = (fileName: any, index: number) => {
		if (index !== -1) {
			images.splice(index, 1);
			setImages(images);
		}
		delete files[fileName];
		setFiles({ ...files });
	};
	return (
		<>
			<div>
				<h1 style={{ textAlign: 'center' }}>Images to pdf - Working</h1>
			</div>
			<FileUploadContainer>
				{/* <InputLabel>{label}</InputLabel> */}
				<img
					alt='images icon'
					height={75}
					src='data:image/png;base64,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'
				/>
				<DragDropText>
					Drag and drop your images anywhere or
				</DragDropText>
				<UploadFileBtn type='button' onClick={handleUploadBtnClick}>
					<i className='fas fa-file-upload' />
					<span>
						{' '}
						Upload {otherProps.multiple ? 'files' : 'a file'}
					</span>
				</UploadFileBtn>
				<FormField
					type='file'
					ref={fileInputField}
					onChange={handleNewFileUpload}
					title=''
					value=''
					{...otherProps}
				/>
			</FileUploadContainer>
			{/* Generates PDF */}
			{images.length > 0 && (
				<>
					<UploadedImages files={files} removeFile={removeFile} />
					<button onClick={generatePdfFromImages} className='button'>
						Generate PDF
					</button>
				</>
			)}
		</>
	);
};
